import { useMemo } from 'react';

import {
  DropdownCircularProgressStyled,
  DropdownLabelStyled,
  DropdownLoadingBoxStyled,
  DropdownMenuItemsAvatarStyled,
  DropdownMenuItemsStyled,
  DropdownMenuItemsTypographyStyled,
  DropdownSelectStyled,
  DropdownStyled,
} from './styled';
import { DropdownType } from './types';

export const Dropdown: DropdownType = (props) => {
  const {
    label, //
    options,
    loading,
    fullWidth,
    ...restProps
  } = props;

  const dropdownMenuItems = useMemo(() => {
    return options.map((option, index) => (
      <DropdownMenuItemsStyled
        key={`${option.value}-${index}`}
        value={option.value}
        disabled={option.disabled}
      >
        <DropdownMenuItemsTypographyStyled color={option.color || 'default'}>
          {option.label}
        </DropdownMenuItemsTypographyStyled>

        {!option.iconSrc ? null : (
          <DropdownMenuItemsAvatarStyled
            variant="square"
            src={option.iconSrc}
          />
        )}
      </DropdownMenuItemsStyled>
    ));
  }, [options]);

  return (
    <DropdownStyled fullWidth={fullWidth}>
      {!label ? null : <DropdownLabelStyled>{label}</DropdownLabelStyled>}

      {!loading ? null : (
        <DropdownLoadingBoxStyled>
          <DropdownCircularProgressStyled />
        </DropdownLoadingBoxStyled>
      )}

      <DropdownSelectStyled fullWidth={fullWidth} {...restProps}>
        {dropdownMenuItems}
      </DropdownSelectStyled>
    </DropdownStyled>
  );
};
